// «¿Qué tengo?», respondido con la lista que devolvió la consulta.
//
// Sale del prototipo (`EntityList` / `EntityRow`), conectado a lo que traen
// `GET /agents/`, `GET /tools/` y `GET /agents/{id}/tools/`.
//
// **No gestiona nada**: no edita, no borra, no abre formularios. Eso vive en la
// sección de cada cosa, y R10 de `brain-agente-maestro` decidió que el Brain
// responde, ejecuta y enlaza, pero no maneja la interfaz por el usuario.

import { useTranslation } from 'react-i18next'
import type { Entidad } from './formas'

interface Props {
  entidades: Entidad[]
  /** Cuántas hay en total: puede ser mayor que las que se enseñan. */
  total?: number
}

const MAXIMO_VISIBLE = 12

export function ListaDeEntidades({ entidades, total }: Props) {
  const { t } = useTranslation()
  const visibles = entidades.slice(0, MAXIMO_VISIBLE)
  const ocultas = entidades.length - visibles.length

  return (
    <div>
      <ul className="space-y-1">
        {visibles.map((e, i) => (
          <li
            key={e.id ?? e.name ?? i}
            className="flex items-baseline gap-2 rounded-md border bg-background/60 px-2 py-1"
          >
            <span
              className={
                e.is_enabled === false
                  ? 'h-1.5 w-1.5 shrink-0 rounded-full bg-muted-foreground/40'
                  : 'h-1.5 w-1.5 shrink-0 rounded-full bg-success'
              }
              aria-hidden
            />
            <span className="text-xs font-medium">{e.display_name || e.name}</span>
            {e.description && (
              <span className="truncate text-xs text-muted-foreground">{e.description}</span>
            )}
            {e.is_enabled === false && (
              <span className="ml-auto shrink-0 text-xs text-muted-foreground">
                {t('brain.apagado')}
              </span>
            )}
          </li>
        ))}
      </ul>
      {(ocultas > 0 || (total !== undefined && total > entidades.length)) && (
        // Se dice cuántas faltan. Una lista cortada en silencio hace leer «tengo
        // doce» a quien tiene cincuenta.
        <p className="mt-1 text-xs text-muted-foreground">
          {t('brain.se_enseñan', { visibles: visibles.length, total: total ?? entidades.length })}
        </p>
      )}
    </div>
  )
}
